import gql from "graphql-tag"

const CREATE_ADDRESS_MODIFICATION = gql`
  mutation createOrderModificationAddresses($orderId: ID!, $input: InputOrderModificationAddresses!) {
    Order {
      createOrderModificationAddresses(orderId: $orderId, input: $input) {
        ... on OrderModificationAddresses{
          id
        }
      }
    }
  }
`

export default CREATE_ADDRESS_MODIFICATION
